<app-admin-header
  style="width: 100%"
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
  [queryParams]="queryParams"
></app-admin-header>
<section class="container-fluid ms-main-bg py-5">
  <div class="container ms-pg-structure">
    <div class="d-flex-between-mob-column" #scrollTarget>
      <div>
        <h4 class="large-h">
          {{ (isEdit ? "Update Topic" : "Create Topic") | translator }}
        </h4>
      </div>
    </div>

    <div class="white-box">
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>

      <div class="row my-4 justify-content-center">
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "the name" | translator }}</h5>
            <input
              type="text"
              class="form-control ms-input"
              [placeholder]="'Topic Name' | translator"
              id="nameInput"
              aria-describedby="emailHelp"
              [(ngModel)]="topicName"
            />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-1">
        <button class="submmit-btn mb-3" (click)="createTopic()">
          {{ (isEdit ? "Update" : "Create") | translator }}
        </button>
        <button *ngIf="isEdit" class="submmit-btn" (click)="cancelEdit()">
          {{ "Cancel" | translator }}
        </button>
      </div>
    </div>
    <div class="my-5">
      <h4 class="large-h mb-0">{{ "Topic List" | translator }}</h4>
      <div *ngIf="topics.length <= 0" class="mt-2">
        <app-no-data></app-no-data>
      </div>
      <ng-container *ngIf="topics.length > 0">
        <div
          class="flex-white-box-row-mob white-box-row"
          *ngFor="let topic of topics; let i = index"
        >
          <div class="d-flex align-items-center mob-w-100 flex-wrap">
            <div class="number-box">
              {{ i + 1 }}
            </div>
            <div
              [pTooltip]="'the name' | translator"
              tooltipPosition="top"
              *ngIf="topic.name"
              class="detail-box"
            >
              {{ topic.name }}
            </div>
            <div
              [pTooltip]="'Created' | translator"
              tooltipPosition="top"
              class="detail-box"
            >
              {{ formatDate(topic.createdAt) }}
            </div>
            <div
              [pTooltip]="'Modified' | translator"
              tooltipPosition="top"
              class="detail-box"
            >
              {{ formatDate(topic.updatedAt) }}
            </div>
          </div>
          <div class="d-flex">
            <div class="circle-btn" (click)="deleteTopic(topic._id, $event)">
              <i class="fa fa-trash"></i>
            </div>
            <div class="circle-btn" (click)="loadTopic(topic)">
              <i class="fa fa-pencil"></i>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<app-footer></app-footer>
